import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
  labelsForCurrentSiteSelector,
  makeDeviceByIdSelector,
  makeLabelsByDeviceIdSelector,
  makeNotificationsTotalByDeviceIdSelector,
  makeAlarmsByDeviceIdSelector,
  makeUsersByDeviceIdSelector,
  membershipsForCurrentFactorySelector,
  pathSelector,
  factoriesToLinesForCurrentUserSelector,
} from '../selectors';
import {
  addLabelToDevice,
  addUserToDevice,
  createLabelInCurrentSite,
  deleteDevice,
  deleteLabel,
  fetchSite,
  moveDevice,
  removeLabelFromDevice,
  removeUserFromDevice,
  transferDevice,
  updateLabel,
  updateDevice,
} from '../actions/entry';
import Device from '../components/Device';

const makeMapStateToProps = () => {
  const deviceByIdSelector = makeDeviceByIdSelector();
  const usersByDeviceIdSelector = makeUsersByDeviceIdSelector();
  const labelsByDeviceIdSelector = makeLabelsByDeviceIdSelector();
  const alarmsByDeviceIdSelector = makeAlarmsByDeviceIdSelector();
  const notificationsTotalByDeviceIdSelector = makeNotificationsTotalByDeviceIdSelector();

  return (state, { id, index }) => {
    const { factoryId } = pathSelector(state);
    const allFactoriesToLines = factoriesToLinesForCurrentUserSelector(state);
    const allFactoryMemberships = membershipsForCurrentFactorySelector(state);
    const allLabels = labelsForCurrentSiteSelector(state);

    const { name, dueDate, timer, coverUrl, siteId, lineId, isPersisted } = deviceByIdSelector(
      state,
      id,
    );

    const users = usersByDeviceIdSelector(state, id);
    const labels = labelsByDeviceIdSelector(state, id);
    const alarms = alarmsByDeviceIdSelector(state, id);
    const notificationsTotal = notificationsTotalByDeviceIdSelector(state, id);

    return {
      id,
      index,
      name,
      dueDate,
      timer,
      coverUrl,
      siteId,
      lineId,
      factoryId,
      isPersisted,
      notificationsTotal,
      users,
      labels,
      alarms,
      allFactoriesToLines,
      allFactoryMemberships,
      allLabels,
    };
  };
};

const mapDispatchToProps = (dispatch, { id }) =>
  bindActionCreators(
    {
      onUpdate: (data) => updateDevice(id, data),
      onMove: (lineId, index) => moveDevice(id, lineId, index),
      onTransfer: (siteId, lineId) => transferDevice(id, siteId, lineId),
      onDelete: () => deleteDevice(id),
      onUserAdd: (userId) => addUserToDevice(userId, id),
      onUserRemove: (userId) => removeUserFromDevice(userId, id),
      onSiteFetch: fetchSite,
      onLabelAdd: (labelId) => addLabelToDevice(labelId, id),
      onLabelRemove: (labelId) => removeLabelFromDevice(labelId, id),
      onLabelCreate: (data) => createLabelInCurrentSite(data),
      onLabelUpdate: (labelId, data) => updateLabel(labelId, data),
      onLabelDelete: (labelId) => deleteLabel(labelId),
    },
    dispatch,
  );

export default connect(makeMapStateToProps, mapDispatchToProps)(Device);
